// extracted by mini-css-extract-plugin
export default {"recipesTable":"uCh4EysizJKzudghxZj9","pagination":"BMwoaMblsqWv9RV4J7wy"};